<template>
    <div>
        <app-header messages="我" detail="租赁流程" pathName="/person/me" pathTo="/person/leaseprocess"></app-header>
        <!--shopcart-->
        <div class="w">
            <div class="wb">
                <div class="news_show bg_w_s">
                    <h1>租赁流程</h1>
                    <div class="news_show_l">
                        <p>1、选择产品：在租罗记平台上选择您所需的产品，点击进入可查看产品详细配置。选择您的租赁方式、租赁时长和租赁设备的数量后，点击“加入购物车”或“立即租赁”到下一步。</p>
                        <p><img src="/static/images/qa_07.jpg"></p>
                        <p>2、加入购物车：点击“加入购物车”按钮之后跳转到购物车页面。选择要结算的商品后，点击“去结算”按钮。</p>
                        <p><img src="/static/images/qa_08.jpg"></p>
                        <p>3、订单结算：要确认收货地址和收货人的联系方式是否准确，如果地址或收件人需要修改，请点击页面右侧的更改地址。在地址确认无误后，并仔细阅读《注册协议及隐私条款租赁协议》。</p>
                        <p><img src="/static/images/qa_09.jpg"></p>
                        <p>4、订单支付：系统将根据您选择的机型及免押金额度自动生成订单，请您选择支付方式。</p>
                        <p><img src="/static/images/qa_10.jpg"></p>
                        <p>5、支付密码：点击支付后页面会弹出输入支付密码窗口。请一定保管好自己的支付密码。输入密码后点击确认支付。</p>
                        <p><img src="/static/images/qa_11.jpg"></p>
                        <p>6、支付成功：成功后我们会在页面看到我们的订单详情。</p>
                        <p><img src="/static/images/qa_12.jpg"></p>
                        <p>7、租赁完成：操作到这里，您就完成了一次租赁过程。请等待我们客服人员的处理，祝您工作愉快！</p>
                    </div>
                    <Right></Right>
                    <div class="clear"></div>
                </div>
            </div>
        </div>
        <!--shopcart end-->

        <app-footer></app-footer>
    </div>
</template>
<script>
    import AppHeader from '../../components/common/Header.vue'
    import AppFooter from '../../components/common/Footer.vue'

    import Right from '../../components/common/Right.vue'
    export default {
        name: "leaseprocess",
        props:['messages','detail'],
        components: {
            AppHeader,
            AppFooter,

            Right
        }
    }
</script>



// WEBPACK FOOTER //
// src/center/person/leaseprocess.vue